import { render, staticRenderFns } from "./prdClassify.vue?vue&type=template&id=87e8e180&scoped=true"
import script from "./prdClassify.vue?vue&type=script&lang=js"
export * from "./prdClassify.vue?vue&type=script&lang=js"
import style0 from "./prdClassify.vue?vue&type=style&index=0&id=87e8e180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e8e180",
  null
  
)

export default component.exports